import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1" }, " Please enter your new password below: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_message = _resolveComponent("message")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, { class: "text-center" }, {
            default: _withCtx(() => [
              _createTextVNode(" Reset Password ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      (!_ctx.done)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["prevent"]))
          }, [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_password_input, {
                  label: "Password",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_async_btn, {
                  type: "submit",
                  label: "Reset",
                  task: _ctx.task,
                  color: "primary",
                  class: "full-width"
                }, null, 8, ["task"])
              ]),
              _: 1
            })
          ], 32))
        : (_openBlock(), _createBlock(_component_q_card_section, {
            key: 1,
            class: "animated fadeIn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_message, null, {
                default: _withCtx(() => [
                  _createTextVNode("Your password has been reset!")
                ]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                to: {name: 'login'},
                color: "primary",
                label: "Click here to login",
                class: "full-width q-mt-md"
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}